import React, { useContext, useState } from 'react'
import { Avatar, Box, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Radio, Typography } from '@mui/material'
import { ThemeContext } from '../../context/ThemeContext'
import { useTranslation } from 'react-i18next'
import SideDrawer from '../components/SidebarMenu'
import { useDispatch, useSelector } from 'react-redux'
import { getAccount, getAccountSummary } from '../../api/request/dashboard/dashboard'
import { setAccountData, setAccountId, setAccountSummary } from '../../store/Slices/accountSummary'
import { setUserDetails } from '../../store/Slices/userSlice'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom'

export default function Users() {
  const { darkMode } = useContext(ThemeContext)
  const { t } = useTranslation()
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { accountId: selectedAccountId } = useSelector((state) => state.accountSummary);
  const accountID = selectedAccountId || localStorage.getItem("accountID")
  const { accountTree = [] } = useSelector((state) => state.accountTree);
  const dispatch = useDispatch()
  const navigate = useNavigate()


  const handleAccountSelect = async (account, userName) => {
    try {
      const response = await getAccount(account.id);
      dispatch(setAccountData(response?.data || {}));
      dispatch(setAccountId(account.id));
      localStorage.setItem("SelectedAccount", account.id);
      localStorage.setItem("accountID", account.id);
      dispatch(setUserDetails({ id: account.clientId, username: userName }));
      fetchAccountSummary(account.id);
      document.title = `${account.id} - ${userName} - Equitas Trader`;
      // setSelectedTab(0);
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };
  const fetchAccountSummary = async (accountID) => {
    try {
      const response = await getAccountSummary(accountID);
      dispatch(setAccountSummary(response?.data || {}));
    } catch (error) {
      console.error("Error fetching account summary:", error);
      dispatch(setAccountSummary({}));
    }
  };

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={1}>
        <Box display="flex" alignItems="center">
          <IconButton onClick={() => navigate('/quote')}><ArrowBackIosNewIcon fontSize="small" /></IconButton>
          <Typography fontSize={18} fontWeight={600} ml={1}>{t('users')}</Typography>
        </Box>
      </Box>

      <Paper elevation={0} sx={{ width: '100%', height: '100%', backgroundColor: darkMode ? "#151924" : "#fff", px: 2 }}>
        <List disablePadding>
          {accountTree.map((item, index) =>
            Object.values(item.accounts || {}).map((account) => {
              const isSelected = account.id == accountID;
              return (
                <ListItem key={account.id} button onClick={() => handleAccountSelect(account, item.client?.fullName || item.client?.userName)} sx={{ px: 2 }}>
                  <ListItemAvatar><Avatar sx={{ bgcolor: "#000" }}><img src="/logo192.png" alt="logo" width={24} height={24} /></Avatar></ListItemAvatar>
                  <ListItemText primary={<Typography fontSize={14} fontWeight={500}>{item.client?.fullName || item.client?.userName}</Typography>} secondary={<Typography fontSize={12} color="text.secondary">Account ID : {account.id}</Typography>} />
                  <Radio checked={isSelected} />
                </ListItem>
              );
            })
          )}
        </List>
      </Paper>
      <SideDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />

    </>
  )
}
